import { t } from '@/i18n';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const modalFormSchema = z.object({
  title: z.string().min(1, t('pages.application_store.components.store_main_banner_schema_modal.schema.required')),
  team_uuid: z.string().optional(),
  source_url: z.string().optional(),
  image: z
    .any()
    .refine(
      file => (file && ACCEPTED_IMAGE_TYPES.includes(file.type)) || !file,
      t('pages.application_store.components.store_main_banner_schema_modal.schema.required_file'),
    ),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
